"use strict";

exports.__esModule = true;
exports.getRowStyles = getRowStyles;
var _Theme = require("../../Theme");
function getRowStyles(theme, rowInfo, rowFormatters, selectedIndex, onRowClick) {
  var style = {};
  if (rowInfo && selectedIndex !== undefined && rowInfo.index === selectedIndex) {
    style = {
      background: (0, _Theme.val)("SelectedListItemBackground")({
        theme: theme
      })
    };
  }
  if (onRowClick) {
    style = Object.assign({}, style, {
      cursor: "pointer"
    });
  }
  if (!rowInfo || !rowFormatters || !rowFormatters.length) {
    return style;
  }
  rowFormatters.forEach(function (rowFormatter) {
    var rowValue = rowInfo.row[rowFormatter.id];
    style = Object.assign({}, style, rowFormatter.formatter(rowValue));
  });
  return style;
}